import ConditionShowRadioButton from './radio.js';

const AVAIABLE_CONDITION_FIELDS = { ConditionShowRadioButton };

const typed_field_comp = {
  props: {
    field: {
      type: Skylark.App.Model.Field.Base,
      required: true
    },
    judgements: Object
  },

  render: function(h) {
    return h(this._getComponent(), {
      props: {
        field: this.field,
        judgements: this.judgements
      }
    });
  },

  methods: {
    _getComponent: function() {
      var type;

      type = `ConditionShow${this.field.type.demodulize()}`;
      return AVAIABLE_CONDITION_FIELDS[type] || AVAIABLE_CONDITION_FIELDS[`${type}Field`];
    }
  }
};

const ConditionShowField = {
  props: {
    condition: {
      type: Skylark.App.Model.YetAnotherWorkflow.Condition,
      required: true
    },
    extendClass: {
      type: String,
      default: ''
    }
  },

  components: {
    'typed-field': typed_field_comp
  },

  computed: {
    field: function() {
      return this.condition.getFieldConditionable();
    }
  },

  template: `
    <div class="form-field" :class='extendClass'>
      <div class="form-field-head">
        <div class="form-field-title text-ellipsis">{{ field.title }}</div>
      </div>
      <div class="form-field-input-container">
        <div class="form-field-input">
          <typed-field :field='field'
                       :judgements='condition.judgements' />
        </div>
      </div>
    </div>
  `
};

export default ConditionShowField;
